<svg
  width="12"
  height="12"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 2a6 6 0 0 0-1 11.917V16H9v2h2v3h2v-3h2v-2h-2v-2.083A6 6 0 0 0 12 2Zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
    style="fill: #FFFFFF !important;"
  />
</svg>
